import { USER } from "./actions";

const INITIALSTATE = {
  loading: false,
  error: "",
  users: [],
  userDetails: "",
  user: {},
  userDelete: {},
};

const user = (state = INITIALSTATE, action) => {
  switch (action.type) {
    case USER.USER_LIST_START:
      return { ...state, loading: true, error: "" };
    case USER.USER_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case USER.USER_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    case USER.USER_READ_START:
      return { ...state, loading: true, error: "" };
    case USER.USER_READ_SUCCESS:
      return { ...state, loading: false, userDetails: action.payload };
    case USER.USER_READ_ERROR:
      return { ...state, loading: false, error: action.payload };

    case USER.USER_ADD_EDIT_START:
      return { ...state, loading: true, error: "" };
    case USER.USER_ADD_EDIT_SUCCESS:
      return { ...state, loading: false, user: action.payload };
    case USER.USER_ADD_EDIT_ERROR:
      return { ...state, loading: false, error: action.payload };

    case USER.USER_DELETE_START:
      return { ...state, loading: true, error: "" };
    case USER.USER_DELETE_SUCCESS:
      return { ...state, loading: false, userDelete: action.payload };
    case USER.USER_DELETE_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default user;